 <template>
    <div class="m-2" :style="`direction:`+lang.dir">
        <b-sidebar backdrop id="popViewCard" width="95%" aria-labelledby="sidebar-no-header-title" no-header style="direction:ltr" right :title="lang.view_card" shadow >
            <template #default="{ hide }">
                <div class="m-1 text-start" style="direction:rtl">
                    <div style="width:150px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class=" btn-sm text-center">
                        <span>{{lang.view_card}}</span>
                    </div>
                    <div @click="hide" id="closecardview" style="text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer;width:100px;" class="btn-danger btn-sm">
                        <span>{{lang.close}}</span>
                    </div>
                </div>
                <v-divider></v-divider>
                <div :style="`direction:`+lang.dir" class="m-2">
                    <v-col cols="12" v-if="showButtons">
                        <div class="backBlack" style="padding:0px;width:100%;text-align:center;">
                            <b-button style="font-size:1.1rem;border:2px solid #fff !important;background:blue !important;width:120px;color:#fff;" class="mytab2 btn btn-sm btn-success m-2" @click="showAttached()" v-b-toggle.add_gallery>{{lang.attachement}}</b-button> 
                            <b-button v-if="card._status_ != 7 && total_payment > 0 && card.status != 2 && card.status != 4" style="font-size:1.1rem;border:2px solid #fff !important;background:red !important;width:150px;color:#fff;" class="mytab2 btn btn-sm btn-success m-2" @click="invpayment()" v-b-toggle.add_addpayment>{{lang.make_payment}}</b-button> 
                            <b-button v-if="card._status_ != 7 && card.invoiceid == 0 && $store.state.licenseType.showInvoiceList" class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:darkgreen !important;font-size:1.1rem;color:#fff;" @click="addInvoice()" v-b-toggle.add_invoice>{{lang.create_invoice}}</b-button> 
                            <b-button  class="mytab1 btn btn-sm btn-default m-2" style="width:130px;background:darkslateblue !important;color:#fff !important;font-size:1.1rem;border:2px solid #fff !important" @click="printPDF(cardid,3)">{{lang.print_card}} </b-button> 
                            <b-button v-if="card._status_ != 7 && card.invoiceid != 0" class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:darkgreen !important;font-size:1.1rem;color:#fff;" @click="printPDF(card.invoiceid,1)">{{lang.view_pdf}}</b-button> 
                            <b-button v-if="card._status_ != 7 && card.sined != ''" class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:darkmagenta !important;font-size:1.1rem;color:#fff;" @click="openSign()">{{lang.customer_sign}}</b-button> 
                            <b-button class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:red !important;font-size:1.1rem;color:#fff;" @click="_chStatus(5)" v-if="card._status_ == 3">{{lang.close_card}}</b-button> 
                            <b-button class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:red !important;font-size:1.1rem;color:#fff;" @click="_chStatus(3)" v-if="card._status_ < 3">{{lang.ready_to_deliver}}</b-button> 
                            <b-button class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:rgb(0, 140, 255) !important;font-size:1.1rem;color:#fff;" @click="_chStatus(7)" v-if="card._status_ <= 3">{{lang.cancel_card}}</b-button> 
                            <b-button class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:rgb(0, 140, 255) !important;font-size:1.1rem;color:#fff;" @click="printWar(card.id)" v-if="$store.state.licenseType.showWarranty">ضمان</b-button> 
                            <!-- <b-button v-if="card._status_ != 3 && card.paid != card.ftotal" class="mytab1 btn btn-sm btn-default m-2" style="border:none !important;width:120px;background:#FFF !important;font-size:1.1rem;color:#000;" @click="printInvo(d)">{{lang.close_card}}</b-button>  -->
                            <img :src="`../whatsappicon.png`" style="border:2px solid #fff !important;width:120px;margin-inline-start: 10px;height: 38px;border-radius: 5px;cursor:pointer" v-if="$store.state.licenseType.innerWhats" @click="openWhatsAPP()" v-b-toggle.send_card_whats />
                            <img :src="`../whatsappicon.png`" style="border:2px solid #fff !important;width:120px;margin-inline-start: 10px;height: 38px;border-radius: 5px;cursor:pointer" v-else @click="openLWhatsAPP()" />
                        </div>
                    </v-col>
                </div>
                <v-row :style="`direction:`+lang.dir" class="m-2">
                    <v-col cols="12" md="12" sm="12" v-if="total_profit < 0">
                        <div style="background: red; color:#fff;padding:5px; border: 1px solid red; text-align:center;">الكرت خاسر بمبلغ اجمالي: {{ total_profit }}</div>
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="text-center backBlack" style="width:20%;border:1px solid #000 !important;">{{ lang.superVisor }}</th>
                                    <td class="text-center" style="border:1px solid #000 !important;">{{ card.superVisor }}</td>
                                    <th class="text-center backBlack" style="width:20%;border:1px solid #000 !important;">{{ lang.card_type }}</th>
                                    <td class="text-center backBlue" style="border:1px solid #000 !important;">{{ card.card_type }}</td>
                                </tr>
                                <tr>
                                    <th class="text-center backBlack" style="width:20%;border:1px solid #000 !important;">{{ lang.cardid }}</th>
                                    <th class="text-center backBlack" style="width:35%;border:1px solid #000 !important;">{{ lang.received_date }}</th>
                                    <th class="text-center backBlack" style="width:35%;border:1px solid #000 !important;">{{ lang.delivery_date }}</th>
                                    <th class="text-center backBlack" style="width:10%;border:1px solid #000 !important;">{{ lang.status }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-center" style="border:1px solid #000 !important;">{{ card.card_id }}</td>
                                    <td class="text-center" style="border:1px solid #000 !important;" v-if="card.received_date">{{ card.received_date.substring(0,10) }}</td>
                                    <td class="text-center" style="border:1px solid #000 !important;" v-else> - </td>
                                    <td class="text-center" style="border:1px solid #000 !important;" v-if="card.delivery_date">{{ card.delivery_date.substring(0,10) }}</td>
                                    <td class="text-center" style="border:1px solid #000 !important;" v-else> - </td>
                                    <td class="text-center" style="border:1px solid #000 !important;" :style="`background:${card._statusbg} !important;color:${card._statuscolor} !important`">{{ card['_status_'+lang.langname] }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <v-simple-table>
                            <thead>
                                <tr v-if="card.customer_type == 1">
                                    <th style="width:80px;border:1px solid #000 !important;">{{ lang.customer_type }}</th>
                                    <td :style="`border:1px solid #000 !important;background:${card._customer_type_bgcolor} !important;color:${card._customer_type_color} !important;`">{{ card['_customer_type_'+lang.langname] }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;">{{ lang.full_name }}</th>
                                    <td style="border:1px solid #000 !important;">{{ card.customer }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;">{{ lang.mobile }}</th>
                                    <td style="width:80px;border:1px solid #000 !important;">{{ card.mobile }}</td>
                                </tr>
                                <!-- <tr v-if="card.customer_type == 1">
                                    <th style="width:80px;">{{ lang.id_number }}</th>
                                    <td >{{ card['id_number'] }}</td>
                                    <th style="width:80px;">{{ lang.owner_name }}</th>
                                    <td>{{ card.owner_name }}</td>
                                </tr> -->
                                <tr v-if="card.customer_type == 2">
                                    <th style="width:80px;border:1px solid #000 !important;;">{{ lang.customer_type }}</th>
                                    <td :style="`width:100px;border:1px solid #000 !important;background:${card._customer_type_bgcolor} !important;color:${card._customer_type_color} !important;`">{{ card['_customer_type_'+lang.langname] }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;">{{ lang.company_name }}</th>
                                    <td style="width:80px;border:1px solid #000 !important;">{{ card.customer }}</td>
                                </tr>
                                <tr v-if="card.customer_type == 3">
                                    <th style="width:80px;border:1px solid #000 !important;">{{ lang.customer_type }}</th>
                                    <td :style="`border:1px solid #000 !important;background:${card._customer_type_bgcolor} !important;color:${card._customer_type_color} !important;`">{{ card['_customer_type_'+lang.langname] }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;">{{ lang.company_name }}</th>
                                    <td style="width:80px;border:1px solid #000 !important;">{{ card.customer }}</td>
                                    <th style="border:1px solid #000 !important;width:80px;">{{ lang.mobile }}</th>
                                    <td>{{ card.mobile }}</td>
                                </tr>
                            </thead>
                        </v-simple-table>
                        <v-simple-table>
                            <thead>
                                <tr v-if="card.customer_type == 3">
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.branch_name }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.client.branch_name }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.order_number }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.order_number }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.request_number }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.request_number }}</td>
                                </tr>
                            </thead>
                        </v-simple-table>
                        <v-simple-table>
                            <thead>
                                <tr v-if="card.customer_type == 3">
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.po_number }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.po_number }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.po_date }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.po_date }}</td>
                                </tr>
                            </thead>
                        </v-simple-table>
                        <v-simple-table>
                            <thead>
                                <tr v-if="card.customer_type == 2">
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.mobile }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.mobile }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.company_vatid }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.client.company_vatid }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.crt_number }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.client.crt_number }}</td>
                                </tr>
                                <tr v-if="card.customer_type == 2 && $store.state.licenseType.carInsuranceContract">
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.afforded_customer_name }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;" colspan="5">{{ card.customer_name }}</td>
                                </tr>
                                <tr v-if="card.customer_type == 2">
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.po_number }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;" colspan="2">{{ card.po_number }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.po_date }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;" colspan="2">{{ card.po_date }}</td>
                                </tr>
                            </thead>
                        </v-simple-table>
                        <v-simple-table>
                            <thead>
                                <tr v-if="card.customer_type == 2">
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.address }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ address }}</td>
                                </tr>
                            </thead>
                        </v-simple-table>
                        <br />
                        <h6 v-if="$store.state.licenseType.cars" style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.car_info }}</h6>
                        <v-simple-table v-for="(item,index) in card.carsjson" :key="index">
                            <thead>
                                <tr>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.plate_number }}</th>
                                    <td>{{ item.plate_number }}</td>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.brand_name }}</th>
                                    <td>{{ item.brand }}</td>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.car_model }}</th>
                                    <td style="width:85px;">{{ item.model }}</td>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.car_year }}</th>
                                    <td>{{ item.made_year }}</td>
                                </tr>
                                <tr>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.car_color }}</th>
                                    <td>{{ item.color }}</td>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.engine_meter }}</th>
                                    <td v-if="item.engine_meter === 'undefined'">0</td>
                                    <td v-else>{{ item.engine_meter }}</td>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.vin_numebr }}</th>
                                    <td colspan="3">{{ item.vin }}</td>
                                </tr>
                                <tr><td style="background:none;border:none !important;"></td></tr>
                            </thead>
                        </v-simple-table>
                        <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.terms_and_conditions }}</h6>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="backBlack">{{ lang.terms }}</th>
                                    <!-- <th class="backBlack" style="width:80px;">{{lang.action}}</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in terms" :key="index">
                                    <td>{{ item.terms }}</td>
                                    <!-- <td></td> -->
                                </tr>
                            </tbody>
                            <!-- <tfoot>
                                <tr>
                                    <th>
                                        <b-form-input class="inborder" v-model="iterms" />
                                    </th>
                                    <th>
                                        <v-btn @click="addTerms()" style="background:green;color:#fff;padding:3px !important;margin-top:3px;">{{ lang.add }}</v-btn>
                                    </th>
                                </tr>
                            </tfoot> -->
                        </v-simple-table>
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                        <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.finance_report }}</h6>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="text-center backBlack">{{ lang.total }}</th>
                                    <th class="text-center backBlack" v-if="$store.state.licenseType.carInsuranceContract">{{ lang.customer_afforded }}</th>
                                    <th class="text-center backBlack">{{ lang.discount }}</th>
                                    <th class="text-center backBlack">{{ lang.vat }}</th>
                                    <th class="text-center backBlack">{{ lang.ftotal }}</th>
                                    <th class="text-center backBlack">{{ lang.paid }}</th>
                                    <th class="text-center backBlack">{{ lang.remain }}</th>
                                    <th class="text-center backBlack" v-for="(item,index) in rowType1" :key="index">{{ item.text }}</th>
                                    <th class="text-center backBlack">{{ lang.wins }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th class="text-center">{{ $convertToComa(card.total,$store.state.licenseType.moneyComma) }}</th>
                                    <th class="text-center" v-if="$store.state.licenseType.carInsuranceContract">{{ $convertToComa(card.customer_afforded,$store.state.licenseType.moneyComma) }}</th>
                                    <th class="text-center" v-if="$store.state.licenseType.canAddDiscountToCard"><b-form-input v-model="card.discount" @change="updateDiscount()" class="inborder" /></th>
                                    <th class="text-center" v-else>{{ card.discount }}</th>
                                    <th class="text-center">{{ $convertToComa($RoundNums(card.vat,2),$store.state.licenseType.moneyComma) }}</th>
                                    <th class="text-center">{{ $convertToComa($RoundNums(card.ftotal,2),$store.state.licenseType.moneyComma) }}</th>
                                    <th class="text-center">{{ $convertToComa($RoundNums(card.paid,2),$store.state.licenseType.moneyComma) }}</th>
                                    <th class="text-center">{{ $convertToComa($RoundNums(total_payment,2),$store.state.licenseType.moneyComma) }}</th>
                                    <th class="text-center" v-for="(item,index) in rowType1" :key="index">
                                        {{ cardType[`rowType_${item.value}`].total }}
                                    </th>
                                    <th class="text-center" style="background:green !important;color:#fff !important;">{{ total_profit }}</th>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <br />
                        <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.payments }}</h6>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="text-center backBlack">{{ lang.voucher_type }}</th>
                                    <th class="text-center backBlack">{{ lang.payment_date }}</th>
                                    <th class="text-center backBlack">{{ lang.payment_amount }}</th>
                                    <th class="text-center backBlack">{{ lang.payment_method }}</th>
                                    <th class="text-center backBlack" style="width:75px;">{{ lang.print }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr  v-for="(item,index) in card.payments" :key="index">
                                    <td class="text-center">{{ item[`_type_${lang.langname}`] }}</td>
                                    <td class="text-center">{{ item.receipt_date }}</td>
                                    <td class="text-center">{{ $convertToComa(item.ftotal,$store.state.licenseType.moneyComma) }}</td>
                                    <td class="text-center">{{ item['_paytype_'+lang.langname] }}</td>
                                    <td class="text-center"  @click="printPDF(item.id,2)" style="border:2px solid #fff;background:blue !important;color:#fff !important;cursor:pointer">{{ lang.print }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.ment_description }}</h6>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="text-center backBlack" v-if="$store.state.licenseType.showCarPlate">{{ lang.plate_number }}</th>
                                    <th class="text-center backBlack" v-if="$store.state.licenseType.showTechs">{{ lang.worker_name }}</th>
                                    <!-- <th class="text-center backBlack">{{ lang.item_code }}</th> -->
                                    <th class="text-center backBlack">{{ lang.ment_description }}</th>
                                    <th class="text-center backBlack">{{ lang.total }}</th>
                                    <th class="text-center backBlack">{{ lang.status }}</th>
                                    <th class="text-center backBlack" colspan="3" v-if="card.invoiceid == 0 && $store.state.licenseType.updateCardDet" style="width:150px;">{{ lang.action }}</th>
                                    <th class="text-center backBlack" colspan="2" v-else-if="card.invoiceid == 0 && !$store.state.licenseType.updateCardDet" style="width:150px;">{{ lang.action }}</th>
                                    <th class="text-center backBlack" v-else style="width:80px;">{{ lang.action }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr  v-for="(item,index) in card.rows" :key="index">
                                    <td class="text-center" v-if="$store.state.licenseType.showCarPlate">{{ item.plate_number }}</td>
                                    <td class="text-center" style="white-space:pre-line;" v-if="$store.state.licenseType.showTechs && !$store.state.licenseType.updateCardDet">{{ item.emp_name }}</td>
                                    <td class="text-center" style="white-space:pre-line;" v-else>
                                        <div @click="showModal(3,index)" style="cursor:pointer;padding:2px;background:green;color:#fff;text-align:center;">اضافة/تعديل</div>
                                        <b-input-group style="display:none;">
                                            <b-form-select
                                            class="selborder"
                                            style="background:#eee !important;color:#000 !important;"
                                            :options="workers"
                                            multiple
                                            v-model="card.rows[index].empid">
                                        </b-form-select>
                                        <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                            <i class="fas fa-arrow-down" style="color:#000"></i>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </td>
                                    <!-- <td class="text-center">{{ item.itemcode }}</td> -->
                                    <td class="text-center" v-if="$store.state.licenseType.updateCardDet" :title="lang.item_code + `: ` + item.itemcode"><b-form-input class="inborder" v-model="card.rows[index].item_name" /></td>
                                    <td class="text-center" v-else :title="lang.item_code + `: ` + item.itemcode">{{ item.item_name }}</td>
                                    <td class="text-center" v-if="$store.state.licenseType.updateCardDet"><b-form-input class="inborder" v-model="card.rows[index].ftotal" /></td>
                                    <td class="text-center" v-else>{{ $convertToComa(item.ftotal,$store.state.licenseType.moneyComma) }}</td>
                                    <td class="text-center" :style="`background:${item._rowStatus_bg} !important;color:${item._rowStatus_color} !important`">{{ item['_rowStatus_'+lang.langname] }}</td>
                                    <td class="text-center" v-if="$store.state.licenseType.updateCardDet && card.invoiceid == 0" @click="updateRows(index)" style="border:2px solid #fff !important;background:blue !important;color:#fff !important;cursor:pointer">{{lang.save}}</td>
                                    <td class="text-center" v-if="card.invoiceid == 0" @click="deleteRowx(item)" style="border:2px solid #fff !important;background:red !important;color:#fff !important;cursor:pointer">{{ lang.delete }}</td>
                                    <td class="text-center" v-if="item.status != 2" @click="finishRowx(item,0)" style="border:2px solid #fff !important;background:green !important;color:#fff !important;cursor:pointer">{{ lang.complete }}</td>
                                    <td class="text-center" v-else @click="finishRowx(item,1)" style="border:2px solid #fff !important;background:red !important;color:#fff !important;cursor:pointer">{{lang.maint_return}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <div v-for="(item,index) in rowType1" :key="index">
                            
                            <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ item.text }}</h6>
                            <v-simple-table>
                                <thead>
                                    <tr>
                                        <th class="text-center backBlack" style="display:none;" v-if="$store.state.licenseType.showCarPlate">{{ lang.plate_number }}</th>
                                        <th class="text-center backBlack" v-if="$store.state.licenseType.showTechs">{{ lang.worker_name }}</th>
                                        <th class="text-center backBlack">{{ lang.description }}</th>
                                        <th class="text-center backBlack" style="width:80px;">{{ lang.qtty }}</th>
                                        <th class="text-center backBlack" style="width:80px;">{{ lang.total }}</th>
                                        <th class="text-center backBlack" style="width:75px;" v-if="card.invoiceid == 0">{{ lang.action }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr  v-for="(itm,key) in cardType[`rowType_${item.value}`].items" :key="key">
                                        <td class="text-center" style="display:none;" v-if="$store.state.licenseType.showCarPlate">{{ itm.plate_number }}</td>
                                        <td class="text-center" style="white-space:pre-line;" v-if="$store.state.licenseType.showTechs">{{ itm.emp_name }}</td>
                                        <td class="text-center" :title="lang.item_code + `: ` + itm.itemcode">{{ itm.item_name }}</td>
                                        <td class="text-center">{{ itm.qty }}</td>
                                        <td class="text-center">{{ $convertToComa(itm.ftotal,$store.state.licenseType.moneyComma) }}</td>
                                        <td class="text-center"  v-if="card.invoiceid == 0" @click="deleteRowx(itm)" style="border:2px solid #fff;background:red !important;color:#fff !important;cursor:pointer">{{ lang.delete }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </div>
                        <div style="display:none">
                            <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.expenses }}</h6>
                            <v-simple-table>
                                <thead>
                                    <tr>
                                        <th class="text-center backBlack" style="display:none;" v-if="$store.state.licenseType.showCarPlate">{{ lang.plate_number }}</th>
                                        <th class="text-center backBlack" v-if="$store.state.licenseType.showTechs">{{ lang.worker_name }}</th>
                                        <th class="text-center backBlack">{{ lang.ment_description }}</th>
                                        <th class="text-center backBlack">{{ lang.qtty }}</th>
                                        <th class="text-center backBlack">{{ lang.total }}</th>
                                        <th class="text-center backBlack" style="width:75px;" v-if="card.invoiceid == 0">{{ lang.action }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr  v-for="(item,index) in card.expense" :key="index">
                                        <td class="text-center" style="display:none;" v-if="$store.state.licenseType.showCarPlate">{{ item.plate_number }}</td>
                                        <td class="text-center" style="white-space:pre-line;" v-if="$store.state.licenseType.showTechs">{{ item.emp_name }}</td>
                                        <!-- <td class="text-center">{{ item.itemcode }}</td> -->
                                        <td class="text-center" :title="lang.item_code + `: ` + item.itemcode">{{ item.item_name }}</td>
                                        <td class="text-center">{{ item.qty }}</td>
                                        <td class="text-center">{{ $convertToComa(item.ftotal,$store.state.licenseType.moneyComma) }}</td>
                                        <td class="text-center"  v-if="card.invoiceid == 0" @click="deleteRowx(item)" style="border:2px solid #fff;background:red !important;color:#fff !important;cursor:pointer">{{ lang.delete }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.temporary_expenses}}</h6>
                            <v-simple-table>
                                <thead>
                                    <tr>
                                        <th class="text-center backBlack" style="display:none;" v-if="$store.state.licenseType.showCarPlate">{{ lang.plate_number }}</th>
                                        <th class="text-center backBlack" v-if="$store.state.licenseType.showTechs">{{ lang.worker_name }}</th>
                                        <th class="text-center backBlack">{{ lang.ment_description }}</th>
                                        <th class="text-center backBlack">{{ lang.qtty }}</th>
                                        <th class="text-center backBlack">{{ lang.total }}</th>
                                        <th class="text-center backBlack" style="width:75px;" v-if="card.invoiceid == 0">{{ lang.action }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr  v-for="(item,index) in card.tem_expense" :key="index">
                                        <td class="text-center" style="display:none;" v-if="$store.state.licenseType.showCarPlate">{{ item.plate_number }}</td>
                                        <td class="text-center" style="white-space:pre-line;" v-if="$store.state.licenseType.showTechs">{{ item.emp_name }}</td>
                                        <!-- <td class="text-center">{{ item.itemcode }}</td> -->
                                        <td class="text-center" :title="lang.item_code + `: ` + item.itemcode">{{ item.item_name }}</td>
                                        <td class="text-center">{{ item.qty }}</td>
                                        <td class="text-center">{{ $convertToComa(item.ftotal,$store.state.licenseType.moneyComma) }}</td>
                                        <td class="text-center"  v-if="card.invoiceid == 0" @click="deleteRowx(item)" style="border:2px solid #fff;background:red !important;color:#fff !important;cursor:pointer">{{ lang.delete }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.costs}}</h6>
                            <v-simple-table>
                                <thead>
                                    <tr>
                                        <th class="text-center backBlack" style="display:none;" v-if="$store.state.licenseType.showCarPlate">{{ lang.plate_number }}</th>
                                        <th class="text-center backBlack" v-if="$store.state.licenseType.showTechs">{{ lang.worker_name }}</th>
                                        <th class="text-center backBlack">{{ lang.ment_description }}</th>
                                        <th class="text-center backBlack">{{ lang.qtty }}</th>
                                        <th class="text-center backBlack">{{ lang.total }}</th>
                                        <th class="text-center backBlack" style="width:75px;" v-if="card.invoiceid == 0">{{ lang.action }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr  v-for="(item,index) in card.cost_expense" :key="index">
                                        <td class="text-center" style="display:none;" v-if="$store.state.licenseType.showCarPlate">{{ item.plate_number }}</td>
                                        <td class="text-center" style="white-space:pre-line;" v-if="$store.state.licenseType.showTechs">{{ item.emp_name }}</td>
                                        <!-- <td class="text-center">{{ item.itemcode }}</td> -->
                                        <td class="text-center" :title="lang.item_code + `: ` + item.itemcode">{{ item.item_name }}</td>
                                        <td class="text-center">{{ item.qty }}</td>
                                        <td class="text-center">{{ $convertToComa(item.ftotal,$store.state.licenseType.moneyComma) }}</td>
                                        <td class="text-center"  v-if="card.invoiceid == 0" @click="deleteRowx(item)" style="border:2px solid #fff;background:red !important;color:#fff !important;cursor:pointer">{{ lang.delete }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </div>
                    </v-col>
                </v-row>
                <v-row :style="`direction:`+lang.dir" class="m-2" v-if="card.invoiceid == 0">
                    <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.add_new_work_expenses }}</h6>
                    <v-simple-table striped hover style="width:100%;">
                        <thead>
                            <tr>
                                <th class="text-center backBlack" style="width:140px;">{{lang.vat_type}}</th>
                                <th class="text-center backBlack" style="width:140px;" v-if="$store.state.licenseType.showTechs">{{lang.row_type}}</th>
                                <th class="text-center backBlack" style="width:140px;">{{lang.worker_name}}</th>
                                <th class="text-center backBlack" style="width:120px;" v-if="$store.state.licenseType.showCarPlate">{{lang.chose_car}}</th>
                                <th class="backBlack" style="width:100px;" v-if="$store.state.licenseType.showItemCode">{{lang.item_code}}</th>
                                <th class="text-center backBlack">{{lang.description}}</th>
                                <th class="text-center backBlack" style="width:50px">{{lang.qtty}}</th>
                                <th class="text-center backBlack" style="width:100px">{{lang.item_price}}</th>
                                <th class="text-center backGreen" style="width:100px">{{lang.total}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="vattypes"
                                        v-model="newrow.vattype">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td>
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="rowType"
                                        v-model="newrow.type">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showTechs">
                                    <div @click="showModal(5,0)" style="cursor:pointer;padding:2px;background:green;color:#fff;text-align:center;">اضافة/تعديل</div>
                                    <b-input-group style="display:none;">
                                        <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="workers"
                                        multiple
                                        v-model="newrow.workers_name">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showCarPlate">
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="currentCars"
                                        v-model="newrow.plate_number">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showItemCode">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.itemcode"
                                        @change="getProd(1)"
                                        >
                                    </b-form-input>
                                </td>
                                <td>
                                    <v-combobox
                                        v-model="newrow.item_name"
                                        :items="workdesk"
                                        small-chips
                                        @change="getItemCode()"
                                    ></v-combobox>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        style="width:50px;"
                                        v-model="newrow.qty"
                                        @change="calcKit()"
                                        id="newitemqty"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        style="width:75px;"
                                        v-model="newrow.item_price"
                                        @change="calcKit()"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.total"
                                        @change="calcKit()"
                                        readonly
                                    ></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="9" class="text-end" style="border-left:none !important;border-right:none !important;border-bottom:none !important">
                                    <v-btn id="addNewRow" @click="addNewRow()" style="background:green;color:#fff;padding:3px !important;margin-top:3px;">{{ lang.add }}</v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-row>

                <v-row :style="`direction:`+lang.dir" class="m-2">
                    <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.action }}</h6>
                    <v-simple-table striped hover style="width:100%;">
                        <thead>
                            <tr>
                                <th class="text-center backBlack" style="width:140px;">{{lang.vat_type}}</th>
                                <th class="text-center backBlack" style="width:140px;">{{lang.row_type}}</th>
                                <th class="text-center backBlack" style="width:140px;" v-if="$store.state.licenseType.showCardPayType">{{lang.payment_method}}</th>
                                <th class="text-center backBlack" style="width:140px;" v-if="$store.state.licenseType.showTechs">{{lang.worker_name}}</th>
                                <th class="text-center backBlack" style="width:120px;" v-if="$store.state.licenseType.showCarPlate">{{lang.chose_car}}</th>
                                <th class="backBlack" style="width:100px;" v-if="$store.state.licenseType.showItemCode && $store.state.licenseType.useItemCode">{{lang.item_code}}</th>
                                <th class="backBlack" style="width:100px;" v-if="$store.state.licenseType.showItemCode && !$store.state.licenseType.useItemCode">{{lang.purchase_inv}}</th>
                                <th class="text-center backBlack">{{lang.item_name}}</th>
                                <th class="text-center backBlack" style="width:50px">{{lang.qtty}}</th>
                                <th class="text-center backBlack" style="width:100px">{{lang.item_price}}</th>
                                <th class="text-center backGreen" style="width:100px">{{lang.total}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="vattypes"
                                        v-model="newrow1.vattype">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td>
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="rowType1"
                                        v-model="newrow1.type">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showCardPayType">
                                    
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="payTypes"
                                        v-model="newrow1.paytype">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showTechs">
                                    <div @click="showModal(4,0)" style="cursor:pointer;padding:2px;background:green;color:#fff;text-align:center;">اضافة/تعديل</div>
                                    <b-input-group style="display:none;">
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="workers"
                                        multiple
                                        v-model="newrow1.workers_name">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showCarPlate">
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="currentCars"
                                        v-model="newrow1.plate_number">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showItemCode && $store.state.licenseType.useItemCode">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.itemcode"
                                        @change="getProd(1)"
                                        >
                                    </b-form-input>
                                </td>
                                <td v-if="$store.state.licenseType.showItemCode && !$store.state.licenseType.useItemCode">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.inv_id"
                                        @change="getProd(2)"
                                        >
                                    </b-form-input>
                                </td>
                                <td>
                                    <v-combobox
                                        v-model="newrow1.item_name"
                                        :items="products"
                                        small-chips
                                        @change="getItemCode1()"
                                    ></v-combobox>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        style="width:50px;"
                                        v-model="newrow1.qty"
                                        @change="calcKit1()"
                                        id="newitemqty"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        style="width:75px;"
                                        v-model="newrow1.item_price"
                                        @change="calcKit1()"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.total"
                                        @change="calcKit1()"
                                        readonly
                                    ></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="9" class="text-end" style="border-left:none !important;border-right:none !important;border-bottom:none !important">
                                    <v-btn id="addNewRow1" @click="addNewRow1()" style="background:green;color:#fff;padding:3px !important;margin-top:3px;">{{ lang.add }}</v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-row>
                <v-row v-if="$store.state.licenseType.cars" :style="`direction:`+lang.dir" class="m-2">
                    <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.car_status_receive }}</h6>
                    <v-col cols="12" md="6" sm="12" v-for="(image,index) in carStatus.images" :key="index">
                        <div style="border:1px solid #000" class="backBlack">{{ image.plate }}</div>
                        <v-row>
                            <v-col cols="12" md="4" sm="12">
                                <div style="border:1px solid #000"><img :src="image.image" style="width:100%"></div>
                            </v-col>
                            <v-col cols="12" md="8" sm="12">
                                <v-simple-table v-for="(items,indo) in carStatus.status" :key="indo">
                                    <tr v-if="items.plate == image.plate">
                                        <td >{{ items.text }}</td>
                                    </tr>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                        
                    </v-col>
                </v-row>
            </template>
        </b-sidebar>
        
        <AddCardPayment ref="cardPayments" />
        <addInvoice ref="addInvoice" />
        <viewCardGallery ref="viewCardGall" />
        <sendCardWhats ref="sendCardWhats" />
        <NewCardTecs ref="showModal" />
    </div>
</template>

<script>
import axios from 'axios'

import {SnotifyPosition} from 'vue-snotify';
import AddCardPayment from '@/components/addCardPayment.vue'
import addInvoice from '@/components/addInvoice.vue'
import viewCardGallery from '@/components/viewCardGallery.vue'
import sendCardWhats from '@/components/sendCardWhats.vue'
import NewCardTecs from '@/components/NewCardTecs.vue'

export default {
    components:{AddCardPayment,addInvoice,viewCardGallery,sendCardWhats, NewCardTecs},
    data() {
        return {
            work_type: 1,
            terms: [],
            iterms: '',
            cardid: 0,
            card: {},
            showButtons: true,
            newrow:{
                vattype: 3,
                empname: '',
                itemcode: '',
                item_name: '',
                qty: 1,
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                plate_number: '',
                workers_name: [],
                type: 1,
                itemid: 0,
                stype: 'service',
            },
            newrow1:{
                vattype: 3,
                empname: '',
                itemcode: '',
                item_name: '',
                qty: 1,
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                plate_number: '',
                workers_name: [],
                type: 1,
                itemid: 0,
                stype: 'spareparts',
                inv_id: '',
                paytype: 0,
            },
            workers:[],
            currentCars:[],
            vattypes:[],
            rowType:[],
            rowType1:[],
            products:[],
            workdesk: [],
            allProducts: [],
            allWorks: [],
            pTypes: [],
            cardType: {
                rowType_2: {options: {}, items: []}
            }
        }
    },
    computed:{
        total_profit: function(){
            
            let t = parseFloat(this.card.total) - parseFloat(this.card.discount) - parseFloat(this.card.customer_afforded);
            for(let i=0;i<this.rowType1.length;i++){
                let val = this.rowType1[i].value;
                if(this.cardType[`rowType_${val}`].options.cost == 1){
                    t = parseFloat(t) - parseFloat(this.cardType[`rowType_${val}`].total)
                }
                if(this.cardType[`rowType_${val}`].options.profit == 1){
                    t = parseFloat(t) + parseFloat(this.cardType[`rowType_${val}`].total)
                }
            }
            return this.$RoundNums(t,2);
        },
        total_payment: function(){
            let t = parseFloat(this.card.ftotal) - parseFloat(this.card.paid);
            for(let i=0;i<this.rowType1.length;i++){
                let val = this.rowType1[i].value;
                if(this.cardType[`rowType_${val}`].options.rowtype == "Payment"){
                    t = parseFloat(t) + parseFloat(this.cardType[`rowType_${val}`].total)
                }
            }
            return this.$RoundNums(t,2);
        },
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                return this.$store.state.lang.en;
                }else{
                return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        address: function(){
            let t = "";
            if(this.card.client.address != '') {
                t = this.card.client.address;
            }else{
                t = this.card.client.building_no + " " + this.card.client.street_name + " ";
                t = t + this.card.client.branch_number + " - " + this.card.client.zipcode + " ";
                t = t + this.card.client.district + " - " + this.card.client.city;
            }
            return t;
        },
        sumTotals: function()
        {
            let t= {
                rows: [],
                full_profit: 0
            }
            
            return t;
        },
        remain: function(){
            let t = this.card.ftotal;
            if(this.card.paid != 0 && this.card.paid != '') {
                t = parseFloat(t) - parseFloat(this.card.paid)
            }
            return t;
        },
        carStatus: function(){
            let t = {images: [],status: []};
            if(typeof this.card._cars === 'undefined') return t;
            for(let i=0;i<this.card._cars.length;i++){
                let hasimg = false;
                for(let j=0;j<this.card.images.length;j++){
                    if(this.card._cars[i].plate_number == this.card.images[j].plate_number){
                        hasimg = true;
                        t.images.push({
                            image: this.card.images[j].bvalue,
                            plate: this.card.images[j].plate_number,
                        })
                    }
                }
                for(let j=0;j<this.card.status.length;j++){
                    
                    if(this.card._cars[i].plate_number == this.card.status[j].plate_number){
                        t.status.push({
                            text: this.card.status[j].bvalue,
                            plate: this.card.status[j].plate_number,
                        })
                    }
                }
                if(!hasimg){
                    t.images.push({
                        image: './img/car-background.png',
                        plate: this.card._cars[i].plate_number
                    })
                }
            }
            return t;
        },
        payTypes: function() {
            return this.pTypes
        }
    },
    created() {
        //setInterval(() => {this.calckInv();},10000);
        this.getUsers();
        this.getStatic();
        this.getProducts();
        this.getPyamentType();
    },
    methods: {
        showModal(type,index) {
            this.$refs.showModal.showtable = true;
            this.$refs.showModal.users = this.workers;
            this.$refs.showModal.type = type;
            this.$refs.showModal.t_index = index;
            if(type == 5){
                console.log(this.newrow)
                this.$refs.showModal.techs = this.newrow.workers_name;
            }else if(type == 3){
                this.$refs.showModal.techs = this.card.rows[index].empid;
            }else if(type == 4){
                this.$refs.showModal.techs = this.newrow.workers_name;
            }
            // console.log(this.workersList)
        },
        updateDiscount(){
            if(this.card.invoiceid != 0) return false;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','updateDiscount');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',this.card.id);
            post.append('data[discount]',this.card.discount);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.getCard(this.card.id);
                // this.paytypeOp = t;

                // this.paytype = res.results.data[0].id;
            })
        },
        getPyamentType(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getPayTypes');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',"all");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.payTypeOp = [];
                for(let i=0;i<res.results.data.length;i++){
                    this.pTypes.push({
                        text: this.$parent.lang.langname == 'ar' ? res.results.data[i].type_name : res.results.data[i].type_name_en,
                        value: res.results.data[i].id
                    })
                }
                // this.paytypeOp = t;

                // this.paytype = res.results.data[0].id;
            })
        },
        updateRows(index){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","updateCardRow");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[row]',JSON.stringify(this.card.rows[index]));
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) =>{
                if(response && response.data){
                    let message = this.lang.successfuly_job;
                    this.$snotify.error(message, this.lang.alert, {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close, 
                                action: (toast) => {
                                    this.$snotify.remove(toast.id); 
                                } 
                            },
                        ]
                    });
                    this.getCard(this.card.id);
                    return false;
                    
                }
            })
        },
        openWhatsAPP() {
            this.$refs.sendCardWhats.cardid = this.card.id;
            this.$refs.sendCardWhats.number_list = this.card.mobile;
        },
        openLWhatsAPP() {
            let mobile = "966"+this.card.mobile.substring(1)
            window.open("https://wa.me/"+mobile,"_blank")
        },
        async _chStatus(id){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
          post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","changeCardStatus");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[id]',this.card.id);
            post.append('data[status]',id);
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post)
            if(response && response.data){
                this.getCard(this.card.id);
                this.iterms = '';
            }
        },
        openSign(){
            // $router.push({path: '/signcard/'+card.id})
            if(this.$store.state.licenseType.showFullsign){
                window.open('/signcard/'+this.card.id,'_blank');
            }else{
                window.open('/signcard/'+this.card.id,'_blank','width:500;height=480');
            }
            
        },
        async addTerms(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","addCardTerms");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[id]',this.card.id);
            post.append('data[terms]',this.iterms);
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post)
            if(response && response.data){
                this.getCard(this.card.id);
                this.iterms = '';
            }
        },
        addInvoice(){
            this.getCard(this.card.id);
            this.$refs.addInvoice.getNewInvoiceID();
            this.$refs.addInvoice.invoice.invtype = 2;
            if(this.card.carsjson.length == 0){
                this.card.carsjson = [{
                    c1: '',
                    c2: '',
                    c3: '',
                    text: '',
                    plate_number: '',
                    color: '',
                    model: '',
                    made_year: '',
                    workdes: '',
                    vin: '',
                    engine_meter: '',
                    next_oil_change: '',
                    brand: '',
                }]
            }else{
                let cars = [];
                for(let i=0;i<this.card.carsjson.length;i++){
                    let c = this.card.carsjson[i].plate_number.split(" ")
                    cars.push({
                        c1: c[0],
                        c2: c[1],
                        c3: c[2],
                        text: c[3],
                        plate_number: this.card.carsjson[i].plate_numebr,
                        color: this.card.carsjson[i].color,
                        model: this.card.carsjson[i].model,
                        made_year: this.card.carsjson[i].made_year,
                        workdes: '',
                        vin: this.card.carsjson[i].vin,
                        engine_meter: this.card.carsjson[i].engine_meter == 'undefined' ? "" : this.card.carsjson[i].engine_meter,
                        next_oil_change: '',
                        brand: '',
                    })
                }
                this.card.carsjson = cars;
            }
            console.log("mycars",this.card.carsjson);
            this.$refs.addInvoice.cars = this.card.carsjson;
            
            this.$refs.addInvoice.customer.mobile = this.card.mobile;
            if(this.card.customer_type == 2 || this.card.customer_type == 3){
                this.$refs.addInvoice.company = this.card.company;
            }
            
            this.$refs.addInvoice.invoice.notes = "";
            this.$refs.addInvoice.customer = this.card.client;
            this.$refs.addInvoice.invoice.work_type = this.work_type;
            this.$refs.addInvoice.cctype = this.card.customer_type;
            this.$refs.addInvoice.invoice.discount = this.card.discount;
            this.$refs.addInvoice.invoice.customer_name = this.card.customer_name;
            this.$refs.addInvoice.invoice.customer_afforded = this.card.customer_afforded;
            this.$refs.addInvoice.company.po_number = this.card.po_number;
            this.$refs.addInvoice.company.po_date = this.card.po_date;
            
            this.$refs.addInvoice.tbrows = this.card.rows;
            this.$refs.addInvoice.cardid = this.card.id;
            this.$refs.addInvoice.calcAll()
            this.$refs.addInvoice.customer.mobile = this.card.mobile;
            this.$refs.addInvoice.getName(0)
            this.$refs.addInvoice.changeCusType(parseFloat(this.card.customer_type) - 1 );
            // console.log(this.$refs.addInvoice.company);
        },
        finishRowx(item,id){
            let message = this.lang.are_you_sure;
            if(id == 1){
                message = this.lang.are_you_sure;
            }
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.agree, 
                            action: (toast) => {
                                this.finishRow(item,id);
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                        {
                            text: this.lang.cancel, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                return false;
        },
        deleteRowx(item){
            let message = this.lang.are_you_sure;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.agree, 
                            action: (toast) => {
                                this.deleteRow(item);
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                        {
                            text: this.lang.cancel, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                return false;
        },
        async deleteRow(item){
            
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","deleteItemFromCard");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[id]',item.id);
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ) 
            if(response && response.data && response.data.results && response.data.results.data){
                 this.getProducts();
                 this.getCard(this.card.id);
                let message = this.lang.successfuly_job;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                return false;
            }
        },
        async finishRow(item,id){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","finishItemFromCard");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[id]',item.id);
            post.append('data[doit]',id);
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ) 
            if(response && response.data && response.data.results && response.data.results.data){
                this.getProducts();
                this.getCard(this.card.id);
                let message = this.lang.successfuly_job;
                if(id == 1){
                    message = this.lang.successfuly_job;
                }
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                return false;
            }
        },
        showAttached(){
            this.$refs.viewCardGall.card.cardid = this.card.id;
            this.$refs.viewCardGall.getImages();
        },
        invpayment(){
            this.$refs.cardPayments.id = this.card.id;
            this.$refs.cardPayments.cardid = this.card.card_id;
            this.$refs.cardPayments.cAmount = parseFloat(this.total_payment);
            this.$refs.cardPayments.received_total = parseFloat(this.total_payment);
            this.$refs.cardPayments.received_total = parseFloat(this.total_payment);
        },
        async addNewRow(){
            document.getElementById('addNewRow').style.display = "none";
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","addNewRowToCardDesc");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            Object.keys(this.newrow).forEach(key => {
                if(key == "item_name"){
                    console.log(this.newrow.item_name)
                    if(typeof this.newrow.item_name === 'object'){
                        post.append('data[item_name_op]', JSON.stringify(this.newrow.item_name));
                        Object.keys(this.newrow.item_name).forEach(key1 => {
                            post.append("data[item_name]["+key1+"]",this.newrow.item_name[key1]);
                        });
                    }else{
                        post.append("data[item_name][text]",this.newrow.item_name);
                    }
                }
                else if(key == "workers_name"){
                    if(typeof this.newrow.workers_name === 'object'){
                        let workers_name = '';
                        Object.keys(this.newrow.workers_name).forEach(key1 => {
                            workers_name += (workers_name == '' ? "" : ",") + this.newrow.workers_name[key1]
                        });
                        post.append("data[workers_name]",workers_name);
                    }else{
                        post.append("data[item_name][text]",this.newrow.item_name);
                    }
                }else{
                    post.append("data["+key+"]",this.newrow[key]);
                    
                }
            })
            post.append("data[cardid]",this.card.id)
            
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            document.getElementById('addNewRow').style.display = "inherit";
            if(response && response.data && response.data.results && response.data.results.data){

                this.getProducts();
                this.resetNewrow()
                this.getCard(this.card.id);
            }
            
        },
        async addNewRow1(){
            document.getElementById('addNewRow1').style.display = "none";
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","addNewRowToCard");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            
            Object.keys(this.newrow1).forEach(key => {
                if(key == "item_name"){
                    if(typeof this.newrow1.item_name === 'object'){
                        Object.keys(this.newrow1.item_name).forEach(key1 => {
                            post.append("data[item_name]["+key1+"]",this.newrow1.item_name[key1]);
                        });
                    }else{
                        post.append("data[item_name][text]",this.newrow1.item_name);
                    }
                }else if(key == "workers_name"){
                    if(typeof this.newrow1.workers_name === 'object'){
                        let workers_name = '';
                        Object.keys(this.newrow1.workers_name).forEach(key1 => {
                            workers_name += (workers_name == '' ? "" : ",") + this.newrow1.workers_name[key1]
                        });
                        post.append("data[workers_name]",workers_name);
                    }
                }else{
                    post.append("data["+key+"]",this.newrow1[key]);
                    
                }
            })
            post.append("data[cardid]",this.card.id)
            if(this.newrow1.paytype == 0 && this.newrow1.type == 6){
                const message = "يجب اختيار طريقة الدفع";
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                document.getElementById('addNewRow1').style.display = "";
                return false
            }else if(this.newrow1.type != 6) {
                this.newrow1.paytype = 0
            }
            post.append('data[paytype]',this.newrow1.paytype)
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            document.getElementById('addNewRow1').style.display = "inherit";
            if(response && response.data && response.data.results && response.data.results.data){

                this.getProducts();
                this.resetNewrow()
                this.getCard(this.card.id);
            }
            
        },
        calcKit(){
            if(this.newrow.qty != '' && this.newrow.item_price != ''){
                const q = parseFloat(this.newrow.qty) * parseFloat(this.newrow.item_price);
                this.newrow.total = this.$RoundNums(q);
            }else{
                this.newrow.total = 0;
            }
        },
        calcKit1(){
            if(this.newrow1.qty != '' && this.newrow1.item_price != ''){
                const q = parseFloat(this.newrow1.qty) * parseFloat(this.newrow1.item_price);
                this.newrow1.total = this.$RoundNums(q);
            }else{
                this.newrow1.total = 0;
            }
        },
        getItemCode(){
            for(let i=0;i<this.products.length;i++){
                if(this.products[i].value == this.newrow.item_name.value){
                    this.newrow.itemcode = this.products[i].itemcode
                    this.newrow.itemid = this.products[i].id
                    this.newrow.item_price = this.products[i].item_price
                    this.calcKit();
                    return false;
                }
            }
        },
        getItemCode1(){
            // console.log(this.products);
            for(let i=0;i<this.products.length;i++){
                if(this.products[i].value == this.newrow1.item_name.value){
                    this.newrow1.itemcode = this.products[i].itemcode
                    this.newrow1.itemid = this.products[i].id
                    this.newrow1.item_price = this.products[i].item_price
                    this.calcKit1();
                    return false;
                }
            }
        },
        getProd(id){
            if(id == 1){
                const post = new FormData();
                post.append('defBranch',localStorage.getItem('defBranch'));
                post.append('financeYear',localStorage.getItem('financeYear'));
                post.append("type","getProductByid");
                post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
                post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
                post.append('data[inv_id]',this.newrow.itemcode);

                axios.post(
                    this.$store.state.SAMCOTEC.r_path, post
                ).then((response) => {
                    if(response && response.data && response.data.results && response.data.results.data){
                        this.newrow.itemcode = response.data.results.data.itemcode
                        this.newrow.itemid = response.data.results.data.itemid
                        this.newrow.type = response.data.results.data.type
                        this.newrow.stype = response.data.results.data.stype
                        this.newrow.item_name = response.data.results.data.item_name
                    }
                })
            }else if(id == 2){
                if(this.newrow1.inv_id == '' || this.newrow1.inv_id == 0){
                    this.newrow1.item_name = "";
                    return false;
                }

                const post = new FormData();
                post.append('defBranch',localStorage.getItem('defBranch'));
                post.append('financeYear',localStorage.getItem('financeYear'));
                post.append("type","getPorchaseProducts");
                post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
                post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
                post.append('data[inv_id]',this.newrow1.inv_id);

                axios.post(
                    this.$store.state.SAMCOTEC.r_path, post
                ).then((response) => {
                    if(response && response.data && response.data.results && response.data.results.data){
                        this.products = response.data.results.data
                    }
                })
            }
        },
        async getProducts(){
            // if(this.newrow1.itemcode == ''){
            //     return false;
            // }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getProducts");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[item_number]',this.newrow1.itemcode);
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            
            if(response && response.data && response.data.results && response.data.results.data){
                const res = response.data.results.data;
                const res1 = response.data.results.works;
                this.allProducts = res;
                this.allWorks = res1;
                
                for(let i=0;i<res.length;i++){
                    this.products.push({
                        text: res[i]['item_name'+this.lang.langname],
                        value: res[i]['item_name'+this.lang.langname],
                        id: res[i].id,
                        itemcode: res[i].item_code,
                        item_price: res[i].item_price
                    });
                }
                
                for(let i=0;i<res.length;i++){
                    this.workdesk.push({
                        text: res[i]['item_name'+this.lang.langname],
                        value: res[i]['item_name'+this.lang.langname],
                        id: res[i].id,
                        itemcode: res[i].item_code,
                        item_price: ''
                    });
                }
                
            }
         
        },
        getUsers(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getWorkers");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[item_number]',this.newrow.itemcode);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {

                this.workers = response.data.results.data
                this.newrow.workers_name = [response.data.results.data[0].value]
            });
        },
        resetNewrow(){
            this.newrow = {
                vattype: 3,
                empname: '',
                itemcode: '',
                item_name: '',
                qty: 1,
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                plate_number: this.newrow.plate_number,
                workers_name: [],
                type: 1,
                itemid: 0,
            }
            this.newrow1 = {
                vattype: 3,
                empname: '',
                itemcode: '',
                item_name: '',
                qty: 1,
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                plate_number: this.newrow.plate_number,
                workers_name: [],
                type: 1,
                itemid: 0,
                inv_id: '',
                paytype: 0,
            }
            
        },
        async getCard(id) {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getCurretnCard");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
            post.append("data[id]",id)
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path,post);
            this.card = response.data.results.data;
            this.cardType = response.data.results.data.rowType;
            this.work_type = response.data.results.data.work_type
            this.terms = response.data.results.terms;
            for(let i=0;i<this.card._cars.length;i++){
                this.currentCars.push({
                    text:this.card._cars[i].plate_number,value:this.card._cars[i].plate_number
                })
                if(i==0){
                    this.newrow.plate_number = this.card._cars[i].plate_number
                }
            }
        },
        async getStatic(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getStaticOptions");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
            post.append("data[phrase]","")
            const repsponse = await axios.post(this.$store.state.SAMCOTEC.r_path,post)
            for(let i=0;i<repsponse.data.results.data.length;i++){
                if(repsponse.data.results.data[i].option_phrase == "vattypes"){
                    this.vattypes.push({
                        value: repsponse.data.results.data[i].value,
                        text: (this.lang.langname == "ar") ? repsponse.data.results.data[i].name_ar : repsponse.data.results.data[i].name_en
                    })
                }
                if(repsponse.data.results.data[i].option_phrase == "rowType"){
                    if(repsponse.data.results.data[i].value == 1){
                        this.rowType.push({
                            value: repsponse.data.results.data[i].value,
                            text: (this.lang.langname == "ar") ? repsponse.data.results.data[i].name_ar : repsponse.data.results.data[i].name_en
                        })
                    }else{
                        this.rowType1.push({
                            value: repsponse.data.results.data[i].value,
                            text: (this.lang.langname == "ar") ? repsponse.data.results.data[i].name_ar : repsponse.data.results.data[i].name_en
                        })
                    }
                    
                }
            }
            
        },
        printWar(id){
            window.open('../api/print.php?war='+id, '_blank')
        },
        printPDFx (id,t)
        {
            let pdfFrame = document.body.appendChild(document.createElement('iframe'));
            pdfFrame.style.display = 'none';
            pdfFrame.onload = () => (void pdfFrame.contentWindow.print());
            if(t == 1)
                pdfFrame.src = '../api/print.php?invid='+id;
            if(t == 2)
                pdfFrame.src = '../api/print.php?recpid='+id;
            if(t == 3)
                pdfFrame.src = '../api/print.php?newcard='+id;
        },
        printPDF (id,t)
        {
            // let pdfFrame = document.body.appendChild(document.createElement('iframe'));
            // pdfFrame.style.display = 'none';
            // pdfFrame.onload = () => (void pdfFrame.contentWindow.print());
            let src = '';
            if(t == 1)
                src = '../api/print.php?invid='+id;
            if(t == 2)
                src = '../api/print.php?recpid='+id;
            if(t == 3)
                src = '../api/print.php?newcard='+id;

            window.open(src,"_blank")
        },
    },
}
</script>
<style>
.font-size-14{
  font-size:14px;
}
.mybtn{
  width:100%;
  font-size:.8rem;
  border:0px solid #fff;
}
.mybtn2{
  width:100%;
  font-size:.8rem;
  border:0px solid #fff;
}
.mybtn4{
  width:100%;
  font-size:.8rem;
  background:rgb(15, 90, 230) !important;
  border:0px solid #fff;
}
.mybtn3{
  width:100%;
  font-size:.8rem;
  background:#198754 !important;
  border:0px solid #fff;
}
.mybtn1{
  width:100%;
  font-size:.8rem;
  background:#fe7b33 !important;
  border:0px solid #fff;
}
.v-application .elevation-1{
 box-shadow: none !important;
}
</style>